function bold_dropdowns(){
  //Dropdown to be custom
  var dropdown = $('select[name*="Font Color"], select[name*="Font Color2"]');
  var fonts_dropdown = $('select[name*="Font Choice"], select[name*="Font Choice2"]');
  var default_option = 'Select an option';
  var url_color = "https://cdn.shopify.com/s/files/1/0341/1573/files/";
  var cache_string = '?1306';
  //console.log(cache_string);
    $(dropdown).each(function(){
        var values = [];
        $(this).find('option').each(function(){
          if($(this).val() != ''){
            values.push($(this).val());
          }
        });
      	var selectHtml = '<div class="bold_swatches"><ul>';
      	values.forEach(function(option_value){
          selectHtml += '<li class="swatch" data-option="' + option_value + '" data-option="' + option_value + '" style="background-image: url(' + url_color + option_value.replace(/\s+/g, '').toLowerCase() + '.jpg); background-color: #ccc; "></li>';
      });
      
      
      selectHtml += '</ul></div>';
      $(this).after(selectHtml);
      $(this).hide();

    });
  
    $(fonts_dropdown).each(function(){
        var values = [];
        $(this).find('option').each(function(){
          if($(this).val() != ''){
            values.push($(this).val());
          }
        });
        var selectHtml = '<div class="bold_dropdown"><span class="selected_option">' + default_option + '</span><ul>';
      	values.forEach(function(option_value){
          var dd_option_value = option_value.replace(/ /g, "-");
          selectHtml += '<li data-class="tk-'+dd_option_value.toLowerCase()+'" class="fonts_swatches dropdown_option tk-' + dd_option_value.toLowerCase() + '" data-option="' + option_value + '">' + option_value + '</li>';
      });
      
      
      selectHtml += '</ul></div>';
      $(this).after(selectHtml);
      	$(this).hide();

    });
  
  	$('.bold_dropdown').click(function(){
        if($(this).hasClass('opened')){
          $(this).removeClass('opened'); 
        }
        else {
          $(this).addClass('opened');
          $(this).find('ul').scrollTop(0);
        }
  	});
  
  	$('.dropdown_option').click(function(){
  		var current_option = $(this).attr('data-option');
      	var current_class = $(this).attr('data-class');
      	var current_html = $(this).html(); 
      	$(this).parent().parent().find('.selected_option').attr("class", "selected_option");
      	$(this).parent().parent().find('.selected_option').addClass("fonts_swatches " + current_class);
      	$(this).parent().parent().find('.selected_option').html(current_html);
      	$(this).parents('.bold_dropdown').prev().val(current_option);
  	});
  
  	/*$(document).click(function(event){
      	//if($(event.target).attr('class')!='selected_option'){
      	if($(event.target).hasClass('selected_option')){
        	$('.bold_dropdown.opened').removeClass('opened');
      	}
  	});*/
  
  	$('.bold_swatches li').click(function(){
		var current_option = $(this).attr('data-option');
      	$(this).parents('.bold_swatches').prev().val(current_option);
      	$('.bold_swatches li').removeClass("selected");
      	$(this).addClass("selected");
  	});
}
